/**
 * Editori i shablloneve (TinyMCE), i përfshirë në aplikacion.
 *
 * Ngarkohej nga Tiny Cloud me një çelës API të ngulur. Tiny e lidh çelësin me
 * domenet e regjistruara, dhe te nexuma.app editori dilte i bllokuar: «This
 * domain is not registered… The editor is disabled because the API key could
 * not be validated». Tani TinyMCE vjen nga `node_modules` (licenca GPL) — pa
 * çelës, pa kërkesë jashtë, dhe punon njësoj në çdo domen dhe offline.
 */
import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

// Bërthama, tema, modeli dhe ikonat — e para e regjistron `window.tinymce`,
// të cilin komponenti React e përdor në vend që të shkojë te cloud-i.
import 'tinymce/tinymce';
import 'tinymce/models/dom/model';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/skin';
import 'tinymce/skins/ui/oxide/content';
import 'tinymce/skins/content/default/content';

import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/quickbars';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/wordcount';

const CONTENT_STYLE = `
  body { font-family: 'Times New Roman', Times, serif; font-size:12pt; line-height:1.55; color:#111827; max-width: 760px; margin: 16px auto; }
  h1,h2,h3 { font-family:'Times New Roman', Times, serif; color:#111827; margin:10pt 0 6pt; }
  h1{ font-size:18pt; } h2{ font-size:14pt; } h3{ font-size:12.5pt; }
  table { width:100%; border-collapse: collapse; margin:8pt 0 12pt; }
  th,td { border:1px solid #e5e7eb; padding:6pt 8pt; vertical-align: top; }
  .page-break { page-break-after: always; }
`;

const EditorTemplate = (props) => {
  const editorRef = useRef(null);
  return (
    <Editor
      licenseKey="gpl"
      onInit={(evt, editor) => {
        editorRef.current = editor;
        if (typeof props.onReady === 'function') props.onReady(editor);
      }}
      onEditorChange={(newTxt) => props?.getBackData(newTxt)}
      textareaName={props?.name}
      value={props?.value}
      init={{
        // Stilet janë importuar më lart; pa këto TinyMCE do t'i kërkonte si URL.
        skin: false,
        content_css: false,
        content_style: CONTENT_STYLE,
        // ë, ç ruhen si shkronja, jo si &euml; — shablloni lexohet e kërkohet më lehtë.
        entity_encoding: 'raw',
        promotion: false,
        branding: false,
        height: 600,
        menubar: false,
        plugins: 'advlist autolink charmap code fullscreen link lists pagebreak preview quickbars searchreplace table wordcount',
        toolbar: 'undo redo | blocks fontsize | bold italic underline | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | table pagebreak | tags | removeformat searchreplace | preview fullscreen code',
        toolbar_mode: 'sliding',
        toolbar_sticky: true,
        quickbars_selection_toolbar: 'bold italic underline | h2 h3 | quicklink',
        quickbars_insert_toolbar: false,
        pagebreak_split_block: true,
        contextmenu: 'link table',
        setup: (editor) => {
          const tags = (props.tags || []).map((t) => (typeof t === 'string' ? { key: t, label: t } : t));
          editor.ui.registry.addMenuButton('tags', {
            text: 'Fusha',
            tooltip: 'Fut një fushë dinamike (@…)',
            fetch: (callback) => callback(tags.map((t) => ({
              type: 'menuitem',
              text: t.label || t.key,
              onAction: () => editor.insertContent('@' + (t.key || t.label)),
            }))),
          });
        },
      }}
    />
  );
};

export default EditorTemplate;
